module.exports = __webpack_public_path__ + "static/media/linkedin-poll-werk-jij-op-zondag.0e528cd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/StartPages/images/linkedin-poll-werk-jij-op-zondag.png
// module id = 262
// module chunks = 1